/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__costs_section__total_cost = /** @type {(inputs: {}) => string} */ () => {
	return `Gesamtkosten der Fahrt`
};

const en_route_details__costs_section__total_cost = /** @type {(inputs: {}) => string} */ () => {
	return `Total cost of the trip`
};

const es_route_details__costs_section__total_cost = /** @type {(inputs: {}) => string} */ () => {
	return `Coste total del trayecto`
};

const fr_route_details__costs_section__total_cost = /** @type {(inputs: {}) => string} */ () => {
	return `Coût total du trajet`
};

const it_route_details__costs_section__total_cost = /** @type {(inputs: {}) => string} */ () => {
	return `Costo totale del percorso`
};

const nl_route_details__costs_section__total_cost = /** @type {(inputs: {}) => string} */ () => {
	return `Totale reiskosten`
};

const pt_route_details__costs_section__total_cost = /** @type {(inputs: {}) => string} */ () => {
	return `Custo total do trajeto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__total_cost = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__costs_section__total_cost(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__costs_section__total_cost", locale)
	if (locale === "de") return de_route_details__costs_section__total_cost(inputs)
	if (locale === "en") return en_route_details__costs_section__total_cost(inputs)
	if (locale === "es") return es_route_details__costs_section__total_cost(inputs)
	if (locale === "fr") return fr_route_details__costs_section__total_cost(inputs)
	if (locale === "it") return it_route_details__costs_section__total_cost(inputs)
	if (locale === "nl") return nl_route_details__costs_section__total_cost(inputs)
	return pt_route_details__costs_section__total_cost(inputs)
};